import styled from '@emotion/styled';
import { useListingContext } from '~/editor/plugin/ListingPlugin';

/* ── styled components ── */

const Section = styled.section`
	background-color: white;
	color: black;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-top: 1.5rem;
	padding-bottom: 1.5rem;
	@media (max-width: 767px) {
		display: none;
	}
`;

const Heading = styled.div`
	text-transform: uppercase;
	font-weight: 500;
	font-size: 1.5rem;
	line-height: 2rem;
	letter-spacing: 0.3em;
	text-align: center;
	padding-top: 1.5rem;
	padding-bottom: 1.5rem;
	border-bottom: 10px solid #e5e7eb;
	width: 100%;
	@media (min-width: 768px) {
		font-size: 2.25rem;
		line-height: 2.5rem;
	}
`;

const Grid = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	width: 100%;
	max-width: 80rem;
	gap: 1rem;
	padding-top: 1.5rem;
	@media (min-width: 640px) {
		grid-template-columns: repeat(2, 1fr);
	}
	@media (min-width: 768px) {
		grid-template-columns: repeat(3, 1fr);
	}
`;

const DetailRow = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 1rem;
`;

const Label = styled.div`
	text-align: right;
	font-weight: 500;
`;

/* ── helpers ── */

function formatLotSize(lotAcres?: number, lot?: number) {
	if (lotAcres) {
		return `${lotAcres.toFixed(2)} acres`;
	}
	if (lot) {
		return `${lot.toLocaleString()} sqft`;
	}
	return null;
}

/* ── component ── */

export default function ListingBlockEta() {
	const listing = useListingContext();

	return (
		<Section id="details">
			<Heading>Property Details</Heading>
			<Grid>
				{listing.mls && (
					<DetailRow>
						<Label>Listing ID</Label>
						<div>{listing.mls}</div>
					</DetailRow>
				)}
				{listing.price_formatted && (
					<DetailRow>
						<Label>Listing Price</Label>
						<div>{listing.price_formatted}</div>
					</DetailRow>
				)}
				{listing.beds != null && (
					<DetailRow>
						<Label>Bedrooms</Label>
						<div>{listing.beds}</div>
					</DetailRow>
				)}
				{listing.baths != null && (
					<DetailRow>
						<Label>Bathrooms</Label>
						<div>{listing.baths}</div>
					</DetailRow>
				)}
				{listing.sqft != null && (
					<DetailRow>
						<Label>Square Feet</Label>
						<div>{listing.sqft}</div>
					</DetailRow>
				)}
				{listing.built != null && (
					<DetailRow>
						<Label>Year Built</Label>
						<div>{listing.built}</div>
					</DetailRow>
				)}
				{listing.garage != null && (
					<DetailRow>
						<Label>Garage Size</Label>
						<div>{listing.garage} Cars</div>
					</DetailRow>
				)}
				{listing.lot != null && (
					<DetailRow>
						<Label>Lot Size</Label>
						<div>{formatLotSize(listing.lot_acres, listing.lot)}</div>
					</DetailRow>
				)}
			</Grid>
		</Section>
	);
}
